function mapNoteAuthorFromDto(dto) {
    return { ...dto };
}
export function mapNoteFromDto(dto) {
    return {
        id: dto.id,
        entityKind: dto.entityKind,
        entityId: dto.entityId,
        parentOrderId: dto.parentOrderId,
        body: dto.content,
        author: mapNoteAuthorFromDto(dto.author),
        onBehalfOfName: dto.onBehalfOfName,
        createdAt: new Date(dto.createdAt),
        updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : undefined,
        canEdit: dto.canEdit,
        canDelete: dto.canDelete,
    };
}
export function mapNoteHistoryFromDto(dto) {
    return {
        versions: dto.versions.map(version => ({
            body: version.content,
            author: mapNoteAuthorFromDto(version.author),
            onBehalfOfName: version.onBehalfOfName,
            createdAt: new Date(version.createdAt),
        })),
        isRetired: dto.isRetired,
        retiredAt: dto.retiredAt ? new Date(dto.retiredAt) : undefined,
        retiredBy: dto.retiredBy && mapNoteAuthorFromDto(dto.retiredBy),
    };
}
export function mapEstateAgentMessageFromDto(dto) {
    return {
        id: dto.id,
        body: dto.content,
        visibility: dto.visibility,
        author: mapNoteAuthorFromDto(dto.author),
        isSentByMe: dto.isSentByMe,
        createdAt: new Date(dto.createdAt),
    };
}
